// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import styles from "./textarea.module.scss";

const TextAreaBox = (props) => {
    function handleKeyPress(e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
            props.onDeletePressed();
        }
    }

    return (
        <textarea
            id={props.id}
            className={styles.container}
            value={props.value}
            placeholder={props.placeholder}
            onKeyDown={handleKeyPress}
            readOnly
        />
    );
};

export default TextAreaBox;